import AgentResultDetailView from 'views/agents/agentResultDetailView';

export default class ReaderResultDetailView extends AgentResultDetailView {
    galleryId() {
        return 'blueimp-gallery-carousel-newsroom';
    }
}
